<div class="flex flex-col justify-center items-center">
	<h4>Please not that TD will not be notified of your decline</h4>
	<p class="my-5">Please contact TD directly by phone of fax</p>
	<app-button size="small" (click)="acknowledge()">Acknowledge</app-button>
</div>
